<template>
  <div>
    <button @click.prevent="onClick" type="button" :class="{ disabled: !formId }"
            class="px-4 py-2 rounded bg-blue-500 shadow text-white font-bold">
      {{ buttonLabel }}
    </button>
  </div>
</template>

<script>
export default {
  name: "RedirectButton",
  props: ["value", "field", "id", "hasError", "errorMessage"],
  computed: {
    buttonLabel() {
      return this.field?.templateOptions?.label || "Submit";
    },
    formModel() {
      return this.$store.state.formModel;
    },
    formId() {
      let selectionInput;
      let sourceValue;
      try {
        const options = this.field.options || [];
        selectionInput = this.field?.templateOptions?.selectionInput || "select";
        sourceValue = this.$store.state.formModel[selectionInput];
        const { formId } = options.find(o => o.value === sourceValue);
        return formId;
      } catch (e) {
        // console.log(`Form redirect not configured correctly for ${selectionInput}/${sourceValue}`);
        return "";
      }
    }
  },
  methods: {
    onClick() {
      this.$emit("touched");
      if (!this.formId) {
        return;
      }
      const langCode = this.$store.state.activeLocale || "en";
      this.$store.commit("saveModel");
      this.$router.push(`/webform/${this.formId}/${langCode}`);
    }
  }
};
</script>

<style scoped>
  button.disabled {
    @apply bg-gray-300 text-gray-600 cursor-default;
  }
</style>
